import { render, staticRenderFns } from "./UtilMenuItem.vue?vue&type=template&id=5d11f940&scoped=true"
import script from "./UtilMenuItem.vue?vue&type=script&lang=js"
export * from "./UtilMenuItem.vue?vue&type=script&lang=js"
import style0 from "./UtilMenuItem.vue?vue&type=style&index=0&id=5d11f940&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d11f940",
  null
  
)

export default component.exports